import { Button, Space, Table, notification, Tooltip, Badge, Form } from "antd";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import ModalCreated from "./components/ModalCreated";
import { getUser } from "utils/index";
import { HomeOutlined, EditOutlined, PlusOutlined, CloudUploadOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import userApi from "api/user";
import ModalChangePassword from "./components/ModalChangePassword";
import { rolesAction, rolesActions, rolesAddShop } from "./roles";
import ModalImport from "./components/ModalImport";
import * as XLSX from 'xlsx';
import { toast } from "react-toastify";

const cx = classNames.bind(style);

export default function Shops() {
  const [formImport] = Form.useForm();
  const [formCU] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const { t } = useTranslation()

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description });
  };

  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataShop, setDataShop] = useState();
  const [openImport, setOpenImport] = useState(false);
  const [shops, setShops] = useState([]);

  const getShopManager = async () => {
    try {
      setLoading(true)
      const res = await userApi.getAllShopManager();
      setShops(res.users.filter(item => item.shops.length > 0).sort((a, b) => a.shops[0].shop.shop_code - b.shops[0].shop.shop_code));
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    {
      title: t('shopCode'),
      dataIndex: "shopCode",
      key: "shopCode",
      render: (_, record) => record?.shops?.[0]?.shop?.shop_code
    },
    {
      title: t('shopName'),
      dataIndex: "name",
      key: "name",
      render: (text) => (
        <Tooltip title={text}>
          <span className={cx("ellipsis")}>{text}</span>
        </Tooltip>
      ),
    },
    {
      title: t('userName'),
      dataIndex: "user_name",
      key: "user_name",
    },
    // render ellipsis this column
    {
      title: t('address'),
      dataIndex: "address",
      key: "address",
      render: (_, record) => (
        <Tooltip title={record?.shops?.[0]?.shop?.address}>
          <span className={cx("ellipsis")}>{record?.shops?.[0]?.shop?.address}</span>
        </Tooltip>
      ),
    },
    {
      title: t('seniorAreaManager'),
      dataIndex: "seniorAreaManager",
      key: "seniorAreaManager",
    },
    {
      title: t('departmentManager'),
      dataIndex: "departmentManager",
      key: "departmentManager",
      render: (_, record) => {
        return record?.shops?.[0]?.departmentManagerName || '';
      }
    },
    {
      title: t('areaManager'),
      dataIndex: "areaManager",
      key: "areaManager",
      render: (_, record) => {
        return record?.shops?.[0]?.areaManagerName || '';
      }
    },
    {
      title: t('status'),
      dataIndex: "status",
      key: "status",
      render: (_, record) => {
        return (
          <Badge
            status={record?.shops?.[0]?.shop?.status ? "success" : "processing"}
            text={record?.shops?.[0]?.shop?.status ? t('opened') : t('planned')}
          />
        );
      }
    },
  ];

  if (rolesActions.includes(+getUser().role)) {
    columns.push({
      title: t('action'),
      dataIndex: "action",
      key: "aciton",
      render: (text, row) => {
        return (
          <Space>
            {rolesAction.includes(+getUser().role) && (
              <>
                <Button
                  title={t('edit')}
                  onClick={() => {
                    setOpenModal(true);
                    setDataShop(row);
                  }}
                >
                  <Tooltip title={t('edit')}>
                    <EditOutlined />
                  </Tooltip>

                </Button>
                <ModalChangePassword
                  id={row._id}
                  openNotificationWithIcon={openNotificationWithIcon}
                />
              </>
            )}
          </Space>
        );
      },
    });
  }

  const onCancel = () => {
    setOpenModal(false);
    setDataShop(null);
    formCU.resetFields();
  };

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      if (!dataShop) {
        const res = await userApi.createShopManager(values);
        if (res?.success) {
          onCancel();
          openNotificationWithIcon("success", t('notification'), t('addShopSuccess'));
          getShopManager();
        }
      } else {
        const res = await userApi.updateShopManager({
          ...values,
          shop_id: dataShop.shops[0].shop._id,
          user_id: dataShop._id
        });
        if (res?.success) {
          onCancel();
          openNotificationWithIcon("success", t('notification'), t("updateShopSuccess"));
          getShopManager();
        }
      }
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    } finally {
      setLoading(false);
    }
  };

  const onImport = async (values) => {
    try {
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;
      reader.onload = async (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        if (Array.isArray(data) && data.length >= 2) {
          let payload = []
          let error = ''
          data.filter(item => item.length > 0 && item).forEach((item, idx) => {
            if (idx > 0) {
              const [
                shop_code,
                name,
                address

              ] = item

              payload.push({
                shop_code,
                name,
                address,
                username: 'Shop' + shop_code,
                password: 'Happy1234'
              })

            }
          })
          if (!error) {
            try {
              setLoading(true);
              await userApi.importShopManager(payload);
              openNotificationWithIcon("success", t('notification'), t('importSuccess'));
              getShopManager()
              closeModalImport()
            } catch (error) {
              openNotificationWithIcon("error", t('error'), t('hasError'));
            } finally {
              setLoading(false);
            }
          } else {
            openNotificationWithIcon("error", t('error'), error || t('hasError'));
          }

        } else toast.error("Import error!")

        /* Update state */
      };
      if (rABS) reader.readAsBinaryString(values.upload[0].originFileObj);
      else reader.readAsArrayBuffer(values.upload[0].originFileObj);
    } catch (error) {
      // toast.error(error?.response?.data || ERROR_OCCUR)
    }
  }

  const closeModalImport = () => {
    setOpenImport(false)
    formImport.resetFields()
  }

  useEffect(() => {
    getShopManager()
  }, []);

  return (
    <div className={cx("page-shop")}>
      {contextHolder}
      <ModalImport loading={loading} show={openImport} onFinish={onImport} form={formImport} onCancel={closeModalImport} />
      <div className={cx("title")}>
        <p>{t('listShop')}</p>
        {rolesAddShop.includes(+getUser().role) && (
          <Space>
            <Button onClick={() => setOpenModal(true)} icon={<PlusOutlined />}>
              {t('addShop')}
            </Button>
            <Button onClick={() => setOpenImport(true)} icon={<CloudUploadOutlined />}>
              {t('import')}
            </Button>
          </Space>
        )}
      </div>
      <Table loading={loading} columns={columns} dataSource={shops} bordered />
      <ModalCreated
        form={formCU}
        openModal={openModal}
        onCancel={onCancel}
        dataShop={dataShop}
        handleSubmit={onSubmit}
      />
    </div>
  );
}
